'use client';
import { useEffect, useState } from 'react';

export const loadAffirmScript = async (
  AFFIRM_SCRIPT_URL: string,
  PUBLIC_API_KEY: string,
): Promise<boolean> => {
  return new Promise((resolve, reject) => {
    if (document.querySelector('script[data-affirm]')) {
      console.log('Affirm script already loaded');
      return resolve(true);
    }

    const script = document.createElement('script');
    script.setAttribute('data-affirm', 'true');
    script.src = AFFIRM_SCRIPT_URL;
    script.async = true;

    script.onload = () => {
      window._affirm_config = {
        public_api_key: PUBLIC_API_KEY,
        script: AFFIRM_SCRIPT_URL,
      };

      if (window.affirm?.ui?.ready) {
        window.affirm.ui.ready(() => {
          console.log('Affirm script loaded successfully');
          resolve(true);
        });
      } else {
        resolve(true);
      }
    };

    script.onerror = () => {
      console.error('Failed to load the Affirm script');
      reject(new Error('Failed to load Affirm script'));
    };

    document.body.appendChild(script);
  });
};

const useAffirmScript = (
  AFFIRM_SCRIPT_URL: string,
  PUBLIC_API_KEY: string,
): boolean => {
  const [isScriptLoaded, setIsScriptLoaded] = useState(false);

  useEffect(() => {
    let isMounted = true;

    // Loading Affirm script
    loadAffirmScript(AFFIRM_SCRIPT_URL, PUBLIC_API_KEY)
      .then(() => {
        if (isMounted) {
          setIsScriptLoaded(true);
          console.log('Affirm script is ready.');
        }
      })
      .catch((error) => {
        setIsScriptLoaded(false);
        console.error('Error loading Affirm script:', error);
      });

    return () => {
      isMounted = false;
    };
  }, [AFFIRM_SCRIPT_URL, PUBLIC_API_KEY]);

  return isScriptLoaded;
};

export default useAffirmScript;
